import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'filterPipeTicketOpen'
})
export class FilterPipeTicketOpen implements PipeTransform {
    transform(open_tickets: any, term?: any): any {
        if (term === undefined) return open_tickets;
        if (term === null) return open_tickets;

        if (open_tickets != null) {
            return open_tickets.filter(function (open_ticket) {
                if (open_ticket.number != undefined)
                    if (open_ticket.number.toString().toLowerCase().includes(term.toLowerCase()))
                        return open_ticket;
                if (open_ticket.cash_static != undefined)
                    if (open_ticket.cash_static.toString().toLowerCase().includes(term.toLowerCase()))
                        return open_ticket;
                if (open_ticket.type != undefined)
                    if (open_ticket.type.toString().toLowerCase().includes(term.toLowerCase()))
                        return open_ticket;
                if (open_ticket.payment_type != undefined)
                    if (open_ticket.payment_type.toString().toLowerCase().includes(term.toLowerCase()))
                        return open_ticket;
                if (open_ticket.amount != undefined)
                    if (open_ticket.amount.toString().toLowerCase().includes(term.toLowerCase()))
                        return open_ticket;
                if (open_ticket.date != undefined)
                    if (moment(new Date(open_ticket.date.toDate())).format("DD/MM/YYYY HH:mm:ss").toString().toLowerCase().includes(term.toLowerCase()))
                        return open_ticket.date;


            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-tickets/filter-topen.pipe.ts